export const intersectionObserver = (element, callback) => {
    if (window.IntersectionObserver) {
        const iso = new window.IntersectionObserver((entries) => {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio) {
                callback && callback();
            }
        }, {
            threshold: [0]
        });
        element && iso.observe(element);
        return iso;
    }
    else {
        return undefined;
    }
};
export const getElementLeft = (element) => {
    let actualLeft = element.offsetLeft;
    let current = element.offsetParent;
    while (current !== null) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
    }
    return actualLeft;
};
export const getElementTop = (element) => {
    let actualTop = element.offsetTop;
    let current = element.offsetParent;
    while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
    }
    return actualTop;
};
